import { Select } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api, podatki } from '../api/odjemalec';
import { opisVozila, type VoziloStranke } from './delavnica';

/** Izbira vpisanega vozila stranke (sprejem vozila, termin) z iskanjem po registrski, VIN, vozilu ali lastniku (prvih 20 zadetkov). */
export function IzbiraVozila({
  izbrano,
  izberi,
  napaka,
  obvezno = true,
}: {
  izbrano: VoziloStranke | null;
  izberi: (v: VoziloStranke | null) => void;
  napaka?: string;
  obvezno?: boolean;
}) {
  const [iskanje, setIskanje] = useState('');
  // ko je izbrano vozilo, je v polju njegova oznaka – z njo ne iščemo (sicer bi se iskanje sprožalo v krogu)
  const oznakaIzbranega = izbrano?.id ? oznaka(izbrano) : null;
  const [zakasnjeno] = useDebouncedValue(iskanje === oznakaIzbranega ? '' : iskanje, 300);
  const zadetki = useQuery({
    queryKey: ['izbira-vozila-stranke', zakasnjeno],
    queryFn: ({ signal }) =>
      podatki(
        api.GET('/api/delavnica/vozila/pregled', {
          signal,
          params: { query: { iskanje: zakasnjeno || undefined, velikost: 20 } },
        }),
      ),
    placeholderData: keepPreviousData,
  });
  const vozila = new Map<string, VoziloStranke>();
  (zadetki.data?.vsebina ?? []).forEach((v) => vozila.set(String(v.id), v));
  // izbrano vozilo ima vedno isto oznako, tudi če je le delno (npr. s kompleta gum) in ga zadetki vrnejo polnega
  if (izbrano?.id) {
    vozila.set(String(izbrano.id), izbrano);
  }
  return (
    <Select
      label="Vozilo"
      placeholder="Registrska, VIN, znamka ali lastnik …"
      withAsterisk={obvezno}
      searchable
      clearable
      leftSection={<IconSearch size={16} />}
      data={[...vozila.entries()].map(([value, v]) => ({ value, label: oznaka(v) }))}
      value={izbrano?.id ? String(izbrano.id) : null}
      onChange={(v) => izberi(v ? (vozila.get(v) ?? null) : null)}
      searchValue={iskanje}
      onSearchChange={setIskanje}
      filter={({ options }) => options}
      nothingFoundMessage={zadetki.isFetching ? 'Iščem …' : 'Ni zadetkov – vpišite novo vozilo'}
      error={napaka}
    />
  );
}

function oznaka(v: VoziloStranke): string {
  return opisVozila(v) || `#${v.id}`;
}
